module.exports = __webpack_public_path__ + "img/epr@2x.079992c9.webp";